import { getAltImageSuggestions, getBulkAltImageSuggestions } from '@wix/ambassador-promote-seo-v1-alt-text-suggestions/http';
export const OPENAI_ERROR_CODES = {
  CREATION_FAILURE: 'OPENAI_API_CREATION_FAILURE',
  GET_COMPLETION_FAILURE: 'OPENAI_API_GET_COMPLETION_FAILURE',
  MODERATION_FLAGGED: 'OPENAI_API_IS_MODERATION_FLAGGED_FAILURE'
};
export const fetchBulkAltTextSuggestions = async (httpClient, request) => {
  try {
    const {
      data
    } = await httpClient.request(getBulkAltImageSuggestions(request));
    return data.altTextSuggestions || [];
  } catch (error) {
    var _response;
    throw new Error((error == null || (_response = error.response) == null || (_response = _response.data) == null || (_response = _response.details) == null || (_response = _response.applicationError) == null ? void 0 : _response.code) ?? 'Unknown error');
  }
};
export const fetchSingleAltTextSuggestions = async function (httpClient, errorHandler, request, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    failedToGenerateMessage = 'Failed to generate alt text'
  } = options;
  try {
    const {
      data
    } = await errorHandler.withErrorHandler(async () => httpClient.request(getAltImageSuggestions(request)), {
      errorCodesMap: {
        applicationError: {
          [OPENAI_ERROR_CODES.CREATION_FAILURE]: () => ({
            message: failedToGenerateMessage
          }),
          [OPENAI_ERROR_CODES.GET_COMPLETION_FAILURE]: () => ({
            message: failedToGenerateMessage
          }),
          [OPENAI_ERROR_CODES.MODERATION_FLAGGED]: () => ({
            message: failedToGenerateMessage
          })
        }
      }
    });
    return data.altTextSuggestions || {};
  } catch (error) {
    console.error('Failed to fetch single alt text suggestions', error);
    throw error;
  }
};
//# sourceMappingURL=alt-text-suggestions-api.js.map